import * as moment from "moment";
import { Column } from "../../pb-screen/models/application.user.interface";
import { PlanningBlock } from "../../pb-screen/models/planning-block/planning-block.interface";
import { ActionIcons } from "../../shared/action.icons.enum";
import { isOfSelectedContainerState } from "../../shared/check.container.state";
import { isOfSelectedPlanningState } from "../../shared/check.planning.state";
import { getFilteredPlanningBlocksBySearchText } from "../../shared/filter.by.text";
import { IN_PROGRESS, PLANNED, PRE_PLANNED, TO_BE_PLANNED, RE_USED } from "../../shared/models/status-type.interface";
import { ContainerState, PlanningState, QuickFilter } from "../models/depot-out.interface";
import { ContainerReleaseStatus } from "../../pb-screen/models/pb-screen.interface";

const nullString = "0001-01-01";
const nullNavisionString = "1753-01-01T00:00:00";

export function isDateValid(dateAsString: string) {
  var isNull = dateAsString.indexOf(nullString) > -1 || dateAsString.indexOf(nullNavisionString) > -1;
  return !isNull;
}

export function filterPlanningBlocks(depotOutPlanningBlocks: PlanningBlock[], quickFilter: QuickFilter,
  textFilter: string, sessionDepotOutColumnSelection: Column[], searchMode: boolean = false): PlanningBlock[] {
  let planningBlocks: PlanningBlock[] = [...depotOutPlanningBlocks];
  const matches: PlanningBlock[] = [];

  if (textFilter.length > 0) {
    planningBlocks = getFilteredPlanningBlocksBySearchText(planningBlocks,
      textFilter, sessionDepotOutColumnSelection);
  }

  if (!quickFilter)
    return planningBlocks;

  for (const planningblock of planningBlocks) {
    let isStartDateMatch: boolean = true, isEndDateMatch: boolean = true;
    if (quickFilter.startDate &&
      quickFilter.startDate.toString().length > 0) {
      if (
        isDateValid(planningblock.startFrom.toString())) {
        const filterDate = moment(Date.parse(quickFilter.startDate.toString())).hours(0).minutes(0).seconds(0).utc();

        if (quickFilter.specificStartDate) {
          isStartDateMatch = (isDateValid(planningblock.startFrom.toString()) && moment(planningblock.startFrom.toString()).isSame(filterDate, 'day'));

        }
        else {
          isStartDateMatch = (isDateValid(planningblock.startFrom.toString()) && moment(planningblock.startFrom.toString()).isSameOrAfter(filterDate))

        }
      }
      else isStartDateMatch = false;
    }

    if (quickFilter.endDate &&
      quickFilter.endDate.toString().length > 0) {
      if (isDateValid(planningblock.endUntil.toString())) {

        const filterDate = moment(Date.parse(quickFilter.endDate.toString())).hours(23).minutes(59).seconds(59).utc();

        if (quickFilter.specificEndDate) {
          isEndDateMatch = (isDateValid(planningblock.endUntil.toString()) && moment(planningblock.endUntil.toString()).isSame(filterDate, 'day'));
        }
        else {
          isEndDateMatch = (isDateValid(planningblock.endUntil.toString()) && moment(planningblock.endUntil.toString()).isSameOrBefore(filterDate));
        }
      }
      else isEndDateMatch = false;
    }

    if (!isStartDateMatch || !isEndDateMatch) continue;
    const isACustomerMatch: boolean = isCustomerSearchMatch(quickFilter, planningblock, searchMode);
    const isContainerTypeMatch: boolean = isContainerTypeSearchMatch(quickFilter, planningblock, searchMode);
    const isFirstActionMatch: boolean = isFirstActionSearchMatch(quickFilter, planningblock, searchMode);
    const isLastActionMatch: boolean = isLastActionSearchMatch(quickFilter, planningblock, searchMode);
    const isLastPlanAddressSearchNameMatch: boolean =
      isLastPlanAddressSearchNameSearchMatch(quickFilter, planningblock, searchMode);
    const isFirstPlanAddressSearchNameMatch: boolean =
      isFirstPlanAddressSearchNameSearchMatch(quickFilter, planningblock, searchMode);
    const isClosingMatch: boolean = isClosingSearchMatch(quickFilter, planningblock);
    const isVGMClosingMatch: boolean = isVGMClosingSearchMatch(quickFilter, planningblock);
    const isPbFirstCollectionFromMatch: boolean = isPbFirstCollectionFromSearchMatch(quickFilter, planningblock);
    const isPlanningStateMatch: boolean = isOfSelectedPlanningState(planningblock,
      quickFilter.planningState as PlanningState);
    const isContainerStatusMatch: boolean = isOfSelectedContainerState(planningblock,
      quickFilter.containerStatus);
    const isLocationMatch: boolean = isLocationSearchMatch(quickFilter, planningblock, searchMode);
    const isCarrierMatch: boolean = isCarrierSearchMatch(quickFilter, planningblock, searchMode);
    const isPlanningGroupMatch: boolean = isPlanningGroupSearchMatch(quickFilter, planningblock);
    const isActionIconFilterMatch: boolean = checkIfIsActionFilterMatch(planningblock, quickFilter);
    const isBookedDateTimeFromMatch: boolean = CheckIfBookedDateTimeFromMatch(quickFilter, planningblock);
    const isBookedDateTimeUntilMatchatch: boolean = CheckIfBookedDateTimeUntilMatch(quickFilter, planningblock);
    const isContainerNoMatch: boolean = CheckContainerNumberMatch(quickFilter, planningblock, searchMode);
    const isVesselExportMatch: boolean = CheckVesselExportMatch(quickFilter, planningblock, searchMode);
    const isVesselImportMatch: boolean = CheckVesselImportMatch(quickFilter, planningblock, searchMode);
    const isdriverMatch: boolean = CheckDriverMatch(quickFilter, planningblock, searchMode);
    const isFileNoMatch: boolean = CheckFileNoMatch(quickFilter, planningblock, searchMode);
    const isOrderNoMatch: boolean = CheckOrderNoMatch(quickFilter, planningblock, searchMode);
    const isDepotInReferenceMatch: boolean = CheckDeortInReferenceMatch(quickFilter, planningblock, searchMode);
    const isDepotOutReferenceMatch: boolean = CheckDeortOutReferenceMatch(quickFilter, planningblock, searchMode);
    if (isACustomerMatch &&
      isFirstActionMatch &&
      isContainerTypeMatch &&
      isLastActionMatch &&
      isLastPlanAddressSearchNameMatch &&
      isFirstPlanAddressSearchNameMatch &&
      isPlanningStateMatch &&
      isContainerStatusMatch &&
      isClosingMatch &&
      isPbFirstCollectionFromMatch &&
      isLocationMatch &&
      isCarrierMatch &&
      isPlanningGroupMatch &&
      isActionIconFilterMatch
      && isVGMClosingMatch && isBookedDateTimeFromMatch && isBookedDateTimeUntilMatchatch
      && (!searchMode || (isContainerNoMatch && isVesselExportMatch && isVesselImportMatch && isdriverMatch && isFileNoMatch && isOrderNoMatch && isDepotInReferenceMatch && isDepotOutReferenceMatch))) {
      matches.push(planningblock);
    }
  }

  return matches;
}

function isCarrierSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.carrier) {
    return planningblock.carrierId.length > 0 &&
      (searchMode ? planningblock.carrierId.toLowerCase().includes(quickFilter.carrier.toLowerCase())
        : planningblock.carrierId.toLowerCase() === quickFilter.carrier.toLowerCase());

  }
  return true;
}

function isPlanningGroupSearchMatch(quickFilter: QuickFilter, planningBlock: PlanningBlock): boolean {
  if (quickFilter.planningGroups && quickFilter.planningGroups.length > 0) {
    return quickFilter.planningGroups.indexOf(planningBlock.planningGroup) > -1;
  }
  return true;
}

function isLocationSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean) {
  if (quickFilter.latestLocationCode) {
    return (planningblock.latestLocationCode.length > 0
      && (searchMode ? planningblock.latestLocationCode.toLowerCase().includes(quickFilter.latestLocationCode.toLowerCase())
        : planningblock.latestLocationCode.toLowerCase() == quickFilter.latestLocationCode.toLowerCase()))
      ;
  }
  return true;
}

function isPbFirstCollectionFromSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock) {
  if (quickFilter.pbFirstCollectionFrom &&
    planningblock.pbFirstCollectionFrom &&
    quickFilter.pbFirstCollectionFrom.toString().length > 0 &&
    planningblock.pbFirstCollectionFrom.toString().length > 0) {
    const quickfilterDate = Date.parse(quickFilter.pbFirstCollectionFrom.toString());
    const pbDateElems = planningblock.pbFirstCollectionFrom.toString().split(/\D+/g);
    const pbDate = Date.parse(pbDateElems[0] + "-" + pbDateElems[1] + "-" + pbDateElems[2]);
    if (quickFilter.specificPbFirstCollectionFrom) {
      return moment.utc(planningblock.pbFirstCollectionFrom).isSame(moment(quickFilter.pbFirstCollectionFrom.toString()));
    } else {
      return moment.utc(planningblock.pbFirstCollectionFrom).isSameOrBefore(moment(quickFilter.pbFirstCollectionFrom.toString()));
    }
  } else if (!planningblock.pbFirstCollectionFrom && quickFilter.pbFirstCollectionFrom) {
    return false;
  }
  return true;
}

function isClosingSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock) {
  var isClosingMatch = true;

  if (quickFilter.closing &&
    planningblock.closingDate &&
    quickFilter.closing.toString().length > 0 &&
    planningblock.closingDate.toString().length > 0) {

    const dateToCompare = new Date(Date.parse(planningblock.closingDate.toString())).setHours(0, 0, 0, 0);
    const filterDate = new Date(Date.parse(quickFilter.closing.toString())).setHours(0, 0, 0, 0);
    var isClosingMatch = false;

    if (quickFilter.specificClosing) {
      isClosingMatch = filterDate === dateToCompare;
    }
    else {
      isClosingMatch = filterDate >= dateToCompare;
    }
  } else if (!planningblock.closingDate && quickFilter.closing) {
    isClosingMatch = false;
  }

  return isClosingMatch;
}

function isVGMClosingSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock) {
  var isVGMClosingMatch = true;

  if (quickFilter.vgmClosing &&
    planningblock.vgmClosing &&
    quickFilter.vgmClosing.toString().length > 0 &&
    planningblock.vgmClosing.toString().length > 0) {
    const dateToCompare = new Date(Date.parse(planningblock.vgmClosing.toString())).setHours(0, 0, 0, 0);
    const filterDate = new Date(Date.parse(quickFilter.vgmClosing.toString())).setHours(0, 0, 0, 0);

    if (quickFilter.specificVgmClosing) {
      isVGMClosingMatch = filterDate === dateToCompare;
    }
    else {
      isVGMClosingMatch = filterDate >= dateToCompare;
    }

  }
  else if (!planningblock.vgmClosing && quickFilter.vgmClosing) {
    isVGMClosingMatch = false;
  }

  return isVGMClosingMatch;
}

function isFirstPlanAddressSearchNameSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean) {
  if (quickFilter.unLoadingPlace &&
    planningblock.firstDeliveryAddressSearchName &&
    quickFilter.unLoadingPlace.length > 0 &&
    planningblock.firstDeliveryAddressSearchName.length > 0) {
    return (
      searchMode ? planningblock.firstDeliveryAddressSearchName.toLowerCase().includes(quickFilter.unLoadingPlace.toLowerCase()) : planningblock.firstDeliveryAddressSearchName.toLowerCase() === quickFilter.unLoadingPlace.toLowerCase())
  } else if (!planningblock.firstDeliveryAddressSearchName
    && quickFilter.unLoadingPlace
    && quickFilter.unLoadingPlace.length) {
    return false;
  }
  return true;
}

function isLastPlanAddressSearchNameSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean) {
  if (quickFilter.loadingPlace &&
    planningblock.firstCollectionAddressSearchName &&
    quickFilter.loadingPlace.length > 0 &&
    planningblock.firstCollectionAddressSearchName.length > 0) {
    return (searchMode ? planningblock.firstCollectionAddressSearchName.toLowerCase().includes(quickFilter.loadingPlace.toLowerCase())
      : planningblock.firstCollectionAddressSearchName.toLowerCase() === quickFilter.loadingPlace.toLowerCase())
  } else if (!planningblock.firstCollectionAddressSearchName
    && quickFilter.loadingPlace
    && quickFilter.loadingPlace.length) {
    return false;
  }
  return true;
}

function isLastActionSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean) {
  if (quickFilter.lastAction &&
    planningblock.lastPlanAction &&
    planningblock.lastPlanAddressSearchName &&
    quickFilter.lastAction.length > 0
  ) {
    
    return (
      (searchMode ? planningblock.lastPlanAddressSearchName.toLowerCase().includes(quickFilter.lastAction.toLowerCase())
        : planningblock.lastPlanAddressSearchName.toLowerCase() === quickFilter.lastAction.toLowerCase()));
  }
  return true;
}

function isFirstActionSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean) {
  if (quickFilter.firstAction &&
    planningblock.firstPlanAddressSearchName &&
    quickFilter.firstAction.length > 0 &&
    planningblock.firstPlanAddressSearchName.length > 0) {
    return (searchMode ? planningblock.firstPlanAddressSearchName.toLowerCase().includes(quickFilter.firstAction.toLowerCase()) :
      planningblock.firstPlanAddressSearchName.toLowerCase() === quickFilter.firstAction.toLowerCase());
  }
  return true;
}

function isContainerTypeSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean) {
  if (quickFilter.containerType &&
    quickFilter.containerType.length > 0) {
    if (/\s/.test(quickFilter.containerType)) {

      return (searchMode ? planningblock.containerOrTrailerType?.toLowerCase().includes(quickFilter.containerType.toLowerCase())
        : planningblock.containerOrTrailerType?.toLowerCase() === quickFilter.containerType.toLowerCase());
    } else {
      return (searchMode ? planningblock.containerOrTrailerType?.toLowerCase().includes(quickFilter.containerType.toLowerCase())
        : planningblock.containerOrTrailerType?.toLowerCase() === quickFilter.containerType.toLowerCase());
    }
  }
  return true;
}

function isCustomerSearchMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean) {
  if (quickFilter.customer &&
    planningblock.customerName &&
    quickFilter.customer.length > 0 &&
    planningblock.customerName.length > 0) {
    return (searchMode ? planningblock.customerName.toLowerCase().includes(quickFilter.customer.toLowerCase())
      : planningblock.customerName.toLowerCase() === quickFilter.customer.toLowerCase());
  }
  return true;
}

function hasActionIcon(specificContainerActions: string, actionIcon: ActionIcons): boolean {
  const containerActions = specificContainerActions.split("|");
  return containerActions.indexOf(actionIcon) !== -1;
}

function hasTarTasCode(depotInRef2) {
  let hasTarTas: boolean = false;
  if (depotInRef2 != null && depotInRef2 != "") {
    hasTarTas = true;
  }
  return hasTarTas;
}





function checkIfIsActionFilterMatch(pb: PlanningBlock, quickFilter: QuickFilter): boolean {
  let filter = quickFilter.iconsFilter;
  if (!filter)
    return true;
  if (filter.important && !pb.important)
    return false;
  if (filter.hasT1Action && pb.t1Document != filter.hasT1Action)
    return false;
  if (filter.hasADRAction && !pb.dangerousGoods)
    return false;
  if (filter.hasContainerAvailable != -1 && pb.containerPoolStatus != filter.hasContainerAvailable)
    return false;
  if (filter.preAnnouncementStatus && pb.dInPreAnnouncementStatus != filter.preAnnouncementStatus)
    return false;
  if (filter.truckAppointmentStatus && pb.dInTruckAppointmentStatus != filter.truckAppointmentStatus)
    return false;
  if (filter.hasWeighingAction && !hasActionIcon(pb.specificContainerActions, ActionIcons.WEIGHING))
    return false;
  if (filter.hasCustomsAction && !hasActionIcon(pb.specificContainerActions, ActionIcons.CUSTOMS))
    return false;
  if (filter.hasScanningAction && !hasActionIcon(pb.specificContainerActions, ActionIcons.SCANNING))
    return false;
  if (filter.hasTarTasCode && !hasTarTasCode(pb.depotInOrderLineRef2))
    return false;
  if (filter.containerReleaseStatus) {
    switch (filter.containerReleaseStatus) {
      case 1:
        return pb.containerReleaseStatus == ContainerReleaseStatus.Required;
      case 2:
        return (pb.containerReleaseStatus == ContainerReleaseStatus.Received || pb.containerReleaseStatus == ContainerReleaseStatus.UnassignDriverSuccess || pb.containerReleaseStatus == ContainerReleaseStatus.RevokeSuccess);
      case 3:
        return (pb.containerReleaseStatus == ContainerReleaseStatus.Revoked || pb.containerReleaseStatus == ContainerReleaseStatus.AssignDriverFailed
          || pb.containerReleaseStatus == ContainerReleaseStatus.TransferFailed || pb.containerReleaseStatus == ContainerReleaseStatus.UnassignDriverFailed
          || pb.containerReleaseStatus == ContainerReleaseStatus.RevokeFailed);
      case 4:
        return (pb.containerReleaseStatus == ContainerReleaseStatus.AssignDriverSuccessful || pb.containerReleaseStatus == ContainerReleaseStatus.TransferSuccessful);
    }
  }
  if (filter.highValue && pb.highValue == "0")
    return false;
  if (filter.temperature && parseFloat(pb.setTemperature) !== filter.temperature)
    return false;
  if (filter.sideLoader && !pb.sideLoader)
    return false;
  if (filter.genset && !pb.genset)
    return false;
  return true;
}


function CheckIfBookedDateTimeFromMatch(quickFilter: QuickFilter, planningblock: PlanningBlock) {
  isBookedDateTimeFromMatch = true;
  if (quickFilter.bookedDateTimeFrom &&
    planningblock.bookedDatetimeFrom &&
    quickFilter.bookedDateTimeFrom.toString().length > 0 &&
    planningblock.bookedDatetimeFrom.toString().length > 0) {

    const dateToCompare = new Date(Date.parse(planningblock.bookedDatetimeFrom.toString())).setHours(0, 0, 0, 0);
    const filterDate = new Date(Date.parse(quickFilter.bookedDateTimeFrom.toString())).setHours(0, 0, 0, 0);
    var isBookedDateTimeFromMatch = false;

    if (quickFilter.specificBookedDateTimeFrom) {
      isBookedDateTimeFromMatch = filterDate === dateToCompare;
    }
    else {
      isBookedDateTimeFromMatch = filterDate >= dateToCompare;
    }
  } else if (!planningblock.bookedDatetimeFrom && quickFilter.bookedDateTimeFrom) {
    isBookedDateTimeFromMatch = false;
  }

  return isBookedDateTimeFromMatch;
}


function CheckIfBookedDateTimeUntilMatch(quickFilter: QuickFilter, planningblock: PlanningBlock) {
  isBookedDateTimeUntilMatch = true;
  if (quickFilter.bookedDateTimeUntil &&
    planningblock.bookedDatetimeUntil &&
    quickFilter.bookedDateTimeUntil.toString().length > 0 &&
    planningblock.bookedDatetimeUntil.toString().length > 0) {

    const dateToCompare = new Date(Date.parse(planningblock.bookedDatetimeUntil.toString())).setHours(0, 0, 0, 0);
    const filterDate = new Date(Date.parse(quickFilter.bookedDateTimeUntil.toString())).setHours(0, 0, 0, 0);
    var isBookedDateTimeUntilMatch = false;

    if (quickFilter.specificBookedDateTimeUntil) {
      isBookedDateTimeUntilMatch = filterDate === dateToCompare;
    }
    else {
      isBookedDateTimeUntilMatch = filterDate >= dateToCompare;
    }
  } else if (!planningblock.bookedDatetimeUntil && quickFilter.bookedDateTimeUntil) {
    isBookedDateTimeUntilMatch = false;
  }

  return isBookedDateTimeUntilMatch;
}
function CheckContainerNumberMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.containerNo) {
    return planningblock.containerNo.length > 0 &&
      (searchMode ? planningblock.containerNo.toLowerCase().includes(quickFilter.containerNo.toLowerCase())
      : planningblock.containerNo.toLowerCase() === quickFilter.containerNo.toLowerCase());

  }
  return true;
}

function CheckFileNoMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.fileNo) {
    return planningblock.fileId.length > 0 &&
      (searchMode ? planningblock.fileId.toLowerCase().includes(quickFilter.fileNo.trim().toLowerCase())
      : planningblock.fileId.toLowerCase() === quickFilter.fileNo.trim().toLowerCase());

  }
  return true;
}

function CheckDriverMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.driverFullName) {
    return planningblock.driver  &&
      (searchMode ? planningblock.driver.name.toLowerCase().includes(quickFilter.driverFullName.trim().toLowerCase())
      : planningblock.driver.name.toLowerCase() === quickFilter.driverFullName.trim().toLowerCase());

  }
  return true;
}

function CheckVesselExportMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.vesselNameExport) {
    return planningblock.exportVesselName.length > 0 &&
      (searchMode ? planningblock.exportVesselName.toLowerCase().includes(quickFilter.vesselNameExport.trim().toLowerCase())
        : planningblock.exportVesselName.toLowerCase() === quickFilter.vesselNameExport.trim().toLowerCase());

  }
  return true;
}

function CheckVesselImportMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.vesselNameImport) {
    return planningblock.importVesselName.length > 0 &&
      (searchMode ? planningblock.importVesselName.toLowerCase().includes(quickFilter.vesselNameImport.trim().toLowerCase())
      : planningblock.importVesselName.toLowerCase() === quickFilter.vesselNameImport.toLowerCase());

  }
  return true;
}
function CheckOrderNoMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.orderNo) {
    return planningblock.orderNumber.length > 0 &&
      (searchMode ? planningblock.orderNumber.toLowerCase().includes(quickFilter.orderNo.trim().toLowerCase())
      : planningblock.orderNumber.toLowerCase() === quickFilter.orderNo.trim().toLowerCase());

  }
  return true;
}
function CheckDeortInReferenceMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.depotInReference1) {
    return planningblock.depotInOrderLineRef1.length > 0 &&
      (searchMode ? planningblock.depotInOrderLineRef1.toLowerCase().includes(quickFilter.depotInReference1.trim().toLowerCase())
      : planningblock.depotInOrderLineRef1.toLowerCase() === quickFilter.depotInReference1.trim().toLowerCase());

  }
  return true;
}
function CheckDeortOutReferenceMatch(quickFilter: QuickFilter, planningblock: PlanningBlock, searchMode: boolean): boolean {
  if (quickFilter.depotOutReference1) {
    return planningblock.depotOutOrderLineRef1.length > 0 &&
      (searchMode ? planningblock.depotOutOrderLineRef1.toLowerCase().includes(quickFilter.depotOutReference1.trim().toLowerCase())
      : planningblock.depotOutOrderLineRef1.toLowerCase() === quickFilter.depotOutReference1.toLowerCase());

  }
  return true;
}

